import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWorker } from '../context/WorkerContext';
import FactorykaOnDemand from '../assets/Factrika-OD.svg';
import ErrorModal from './ErrorModal';
import PhoneOtpForm from './PhoneOtpForm';
import useFcmToken from '../hooks/useFcmToken';

const WorkerLogin = () => {
  const { sendOtp, verifyOtp, loading, logout } = useWorker();
  const navigate = useNavigate();

  const [phone, setPhone] = useState('');
  const [acceptedWhatsApp] = useState(true);
  const [acceptedTerms, setAcceptedTerms] = useState(true);
  const [otp, setOtp] = useState('');
  const [showOtp, setShowOtp] = useState(false);
  const [userId, setUserId] = useState('');
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);

  // Referrer code captured from the WebView injection, sent as utm_source on OTP verify
  const [referralCode, setReferralCode] = useState(null);

  useFcmToken();

  useEffect(() => {
    const token = localStorage.getItem('worker_auth_token');
    if (token) {
      navigate('/lkart/dashboard');
    }
  }, [navigate]);

  // Referrer code listener — captures code from native WebView injection
  useEffect(() => {
    const applyCode = (code) => {
      if (code) {
        setReferralCode(code);
      }
    };

    const handleReferralReady = (event) => {
      const code = event?.detail?.code || window.__referralCode || window.referralCode;
      applyCode(code);
    };

    window.addEventListener('referral-code-ready', handleReferralReady);

    // In case the event fired before this component mounted
    if (window.__referralCode || window.referralCode) {
      applyCode(window.__referralCode || window.referralCode);
    } else {
      try {
        const stored = localStorage.getItem('referralCode');
        if (stored) applyCode(stored);
      } catch (e) {
        // Silent fail
      }
    }

    return () => {
      window.removeEventListener('referral-code-ready', handleReferralReady);
    };
  }, []);

  const handleSendOtp = async () => {
    try {
      if (!acceptedTerms) {
        setError('You must accept the Terms and Conditions to continue.');
        setShowError(true);
        return;
      }
      if (phone.length === 10) {
        logout();
        const id = await sendOtp(phone, acceptedWhatsApp);
        setUserId(id);
        setShowOtp(true);
      }
    } catch (err) {
      setError('Your phone number is not registered with us.');
      setShowError(true);
    }
  };

  const handleVerifyOtp = async () => {
  try {
    if (otp.length === 4) {

      const res = await verifyOtp(userId, otp, { utm_source: referralCode });
      if(res.success)
      {
      navigate('/lkart/dashboard');
      }
      else{
            setError(res.message);
    setShowError(true);

      }
    }
  } catch (err) {
    setError('Invalid OTP. Please try again.');
    setShowError(true);
  }
};

  const handlePhoneChange = (e) => setPhone(e.target.value.replace(/\D/g, ''));
  const handlePhoneKeyPress = (e) => {
    if (e.key === 'Enter' && phone.length === 10 && !loading) handleSendOtp();
  };
  const handleOtpKeyPress = (e) => {
    if (e.key === 'Enter' && otp.length === 4 && !loading) handleVerifyOtp();
  };

  return (
    <>
      <PhoneOtpForm
        logoSrc={FactorykaOnDemand}
        logoClassName="h-10 w-auto"
        headingLines={['Welcome to Factrika']}
        showOtp={showOtp}
        phone={phone}
        onPhoneChange={handlePhoneChange}
        onPhoneKeyPress={handlePhoneKeyPress}
        acceptedWhatsApp={acceptedWhatsApp}
        acceptedTerms={acceptedTerms}
        onAcceptedTermsChange={(e) => setAcceptedTerms(e.target.checked)}
        otp={otp}
        onOtpChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
        onOtpKeyPress={handleOtpKeyPress}
        onSendOtp={handleSendOtp}
        onVerifyOtp={handleVerifyOtp}
        loading={loading}
      />
      <ErrorModal message={error} isOpen={showError} setIsOpen={setShowError} />
    </>
  );
};

export default WorkerLogin;